export enum ConversationTypeEnum {
  All = 'all',
  Instruction = 'instruction',
  Workflow = 'workflow',
  Agent = 'agent',
}

export enum ConversationIconEnum {
  Instruction = 'i-circle-icon',
  Workflow = 'w-circle-icon',
  Agent = 'a-circle-icon'
}
